import { Button } from '@mui/material'

const OverridenHostButton = () => {
  const ohost = localStorage.getItem('ohost')

  const _handleOnClick = () => {
    localStorage.removeItem('ohost')
    window.location.href = '/'
  }

  if (!ohost) {
    return null
  }

  return (
    <Button
      onClick={_handleOnClick}
      variant='contained'
      sx={{
        position: 'fixed',
        top: '10px',
        left: '10px',
        zIndex: 9999
      }}
    >
      Clear overriden host
    </Button>
  )
}

export default OverridenHostButton
